// extracted by mini-css-extract-plugin
module.exports = {"list":"_2XpxN","listData":"_3Oql5","listItem":"_2DQ-7","itemTitle":"_3n5Ed","itemValue":"_3f3p0"};